// extracted by mini-css-extract-plugin
module.exports = {"footer":"style__footer__2-w4e","wrapper":"style__wrapper__fdORs"};